/* @flow */
import React from 'react';
import ActivityRecipient from 'entities/ActivityRecipient';
import EventParticipationView from './EventParticipationView.jsx';
import PaymentCreator from 'payments/components/PaymentCreator.jsx';
import PaymentViewConfirmation from 'payments/components/PaymentViewConfirmation.jsx';
import ActivityBlockedViewContainer from 'payments/containers/ActivityBlockedViewContainer.jsx';
import Activity from 'entities/Activity';
import Transaction from 'entities/Transaction';
import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line

import './styles/RSVPFlow.scss';

type HeaderAlign = 'center' | 'left' | 'right';

type Props = {
  activity: Activity,
  isUnderage: boolean,
  initialRSVP?: ?Attendance,
  headerAlign?: ?HeaderAlign,
  initialActivityRecipient?: ?ActivityRecipient,
  onActivityRecipientUpdated?: ?(activityRecipient: ActivityRecipient) => void,
};

type State = {
  contribute: ?boolean,
  recipient: ?ActivityRecipient,
  transaction: ?Transaction,
};

class RSVPFlow extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  state: State = {
    contribute: null,
    recipient: null,
    transaction: null,
  }

  onRecipientCreated = (recipient: ActivityRecipient, contribute: boolean) => {
    this.setState({ recipient, contribute });
    if (this.props.onActivityRecipientUpdated) {
      this.props.onActivityRecipientUpdated(recipient);
    }
  };

  renderParticipationForm() {
    return (
      <EventParticipationView
        initialRSVP={this.props.initialRSVP}
        activity={this.props.activity}
        editableEventRecipient={this.props.initialActivityRecipient || undefined}
        onRecipientCreated={this.onRecipientCreated}
      />
    );
  }

  renderClosedEvent() {
    const teacherName = this.props.activity.getRequester().getDisplayName();
    const activityTitle = this.props.activity.getTitle();

    const title = `${activityTitle} is closed`;
    const subtext = `To participate in this activity, please contact ${teacherName}.`;

    return <ActivityBlockedViewContainer title={title} subtext={subtext} />;
  }

  renderBlockedEvent() {
    const teacherName = this.props.activity.getRequester().getDisplayName();
    const activityTitle = this.props.activity.getTitle();

    const title = `Please contact ${teacherName}`;
    const subtext = `${activityTitle} is currently closed to participants.`;

    return <ActivityBlockedViewContainer title={title} subtext={subtext} />;
  }

  renderConfirmation() {
    return (
      <PaymentViewConfirmation
        transaction={this.state.transaction}
        activity={this.props.activity}
        recipient={this.state.recipient}
      />
    );
  }

  renderTransactionForm() {
    return (
      <PaymentCreator
        request={this.props.activity}
        recipient={this.state.recipient}
        onComplete={transaction => this.setState({ transaction })}
      />
    );
  }

  render() {
    const { transaction, recipient } = this.state;
    const { activity } = this.props;

    if (!activity) {
      return null;
    }

    let body;
    let title;
    let subtitle;

    if (activity.isBlocked()) {
      body = this.renderBlockedEvent();
    } else if (activity.isClosed()) {
      body = this.renderClosedEvent();
    } else if (!recipient) {
      title = this.props.activity.getTitle();
      subtitle = `Organized by ${this.props.activity.getRequester().getDisplayName()}`;
      body = this.renderParticipationForm();
    } else if (activity.isCollectingMoneyOnline() && this.state.contribute && !transaction) {
      title = 'How would you like to pay for this activity?';
      subtitle = this.props.isUnderage ? 'Please ask your parents to complete the below and pay for your activity' : '';
      body = this.renderTransactionForm();
    } else {
      body = this.renderConfirmation();
    }

    const headerStyles = {
      textAlign: this.props.headerAlign || 'center',
    };

    return (
      <div className="RSVPFlow">
        <div className="RSVPFlow-header" style={headerStyles}>
          {title &&
            <div className="RSVPFlow-header-title">
              {title}
            </div>
          }
          {subtitle &&
            <div className="RSVPFlow-header-subtitle">
              {subtitle}
            </div>
          }
        </div>
        <div>
          {body}
        </div>
      </div>
    );
  }
}

export default RSVPFlow;



// WEBPACK FOOTER //
// ./src/payments/components/RSVPFlow.jsx